export { default, PeriodicaForm } from "./PeriodicaForm.page";
